import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {getLocale} from '@epic-core/common/dist';
import {compactNumberFormatter} from '@epic-visualizations/charts';

import StatisticsTrend from '../../../../sidebar/StatisticsTrend';
import {getMappedValue} from '../../../../../utils/FNUtils';

const TrendWrapper = styled.span<{
    value: number;
}>`
    margin: ${p => p.theme.muiTheme.spacing(0, 1, 0, 0)};
    color: ${p =>
        getMappedValue<string>(p.value, {
            positive: p.theme.muiTheme.palette.success.light,
            negative: p.theme.muiTheme.palette.error.light,
            zero: p.theme.muiTheme.palette.dividerStrong
        })};
`;

export interface TrendProps {
    value: number;
    startAdornmentPositive?: ReactNode;
    startAdornmentNegative?: ReactNode;
    endAdornment?: ReactNode;
}

const HighlightTrend: FC<TrendProps> = ({
    value,
    startAdornmentPositive,
    startAdornmentNegative,
    endAdornment
}: TrendProps) => {
    const formatNumber = compactNumberFormatter(getLocale());

    return (
        <TrendWrapper value={value}>
            {getMappedValue<ReactNode>(value, {
                positive: startAdornmentPositive,
                negative: startAdornmentNegative
            })}
            <StatisticsTrend value={formatNumber(Math.abs(value)) || 0} />
            {value !== 0 && endAdornment}
        </TrendWrapper>
    );
};

export default HighlightTrend;
